import {ValueOf} from 'next/constants'
import {CSSProperties} from 'react'

import classNames from 'classnames/bind'

import BadgeRoundBox from '$components/common/BadgeRoundBox'
import {또래대비_보장조건} from '$constants/insurance/diagnosis'
import {GraphCoverages} from '$hooks/insurance/my/home/diagnosis/useDiagnosisCoverage'
import {formatAmount} from '$utils/formatAmount'
import {get또래대비보장ratio} from '$utils/insurance'

import styles from './radarTooltip.module.scss'

const cx = classNames.bind(styles)

// tooltip 너비 고정값. scss 파일에 정의된 width가 변경되면 이 값도 바꿔야함
export const tooltipWidth = 187

const getColor = (condition: ValueOf<typeof 또래대비_보장조건>) => {
    if (condition === 또래대비_보장조건.매우부족) {
        return 'red200'
    }

    if (condition === 또래대비_보장조건.부족) {
        return 'yellow200'
    }

    return 'blue200'
}

interface RadarTooltipProps {
    coverage: GraphCoverages[number]
    style: CSSProperties
    onClick: () => void
    isShow: boolean
}
export const RadarTooltip = ({coverage, style, isShow, onClick}: RadarTooltipProps) => {
    if (!isShow) {
        return null
    }

    return (
        <div className={cx('article')} style={{...style}} onClick={onClick} role="button">
            <strong className={cx('title')}>{coverage.labelName}</strong>
            <ul className={cx('list')}>
                <li className={cx('item')}>
                    <span className={cx('dot')}>
                        <span className="blind">하늘색 형상의 경우</span>
                    </span>
                    <span className={cx('name')}>또래 평균</span>
                    <b className={cx('amount')}>{formatAmount(coverage.peerAmount, {type: '간단'})}원</b>
                </li>
                <li className={cx('item')}>
                    <span className={cx('dot')}>
                        <span className="blind">네온그린 형상의 경우</span>
                    </span>
                    <span className={cx('name')}>내 보장</span>
                    <b className={cx('amount')}>
                        <BadgeRoundBox
                            text={
                                <>
                                    <span className="blind">또래 평균 대비</span>
                                    {get또래대비보장ratio(coverage.myAmount, coverage.peerAmount)}%
                                </>
                            }
                            weight="medium"
                            color={getColor(coverage.condition)}
                            size="small"
                            articleClassName={cx('badge')}
                        />
                        {formatAmount(coverage.myAmount, {type: '간단'})}원
                    </b>
                </li>
            </ul>
        </div>
    )
}
